import { useQuery } from '@tanstack/react-query'

import { getOnboardingStatus } from '@/requests/users'

export function useOnboardingStatusQuery() {
  return useQuery({
    queryKey: ['onboarding-status'],
    queryFn: async () => {
      const result = await getOnboardingStatus()
      if (result.error) throw new Error(result.error.message)
      return result
    },
  })
}
